import React from 'react'

import {Box, BoxProps} from '../Box/Box'

export function DefaultBox(props: BoxProps) {
  return <Box bgcolor="background.paper" color="text.primary" borderRadius={1} p={3} {...props} />
}
